import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Bell = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M10.5973 14.2C10.5973 9.66874 14.2798 6 18.8167 6H21.1833C25.7202 6 29.4027 9.66873 29.4027 14.2V22.4544C29.4027 22.775 29.5133 23.0862 29.7164 23.3357L33.2329 27.6562C35.0448 29.8822 33.452 33.2 30.589 33.2H9.411C6.54804 33.2 4.95518 29.8822 6.76707 27.6562L10.2836 23.3357C10.4867 23.0862 10.5973 22.775 10.5973 22.4544V14.2ZM18.8167 8C15.3793 8 12.5973 10.7784 12.5973 14.2V22.4544C12.5973 23.2355 12.3279 23.9924 11.8348 24.5982L8.3182 28.9187C7.57658 29.8298 8.22234 31.2 9.411 31.2H30.589C31.7777 31.2 32.4234 29.8298 31.6818 28.9187L28.1652 24.5982C27.6721 23.9924 27.4027 23.2355 27.4027 22.4544V14.2C27.4027 10.7784 24.6207 8 21.1833 8H18.8167ZM16 37C16 36.4477 16.4477 36 17 36H23C23.5523 36 24 36.4477 24 37C24 37.5523 23.5523 38 23 38H17C16.4477 38 16 37.5523 16 37Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Bell;
